export const load = () => ({
	h1: 'Tape Mesurement Form',
	title: 'Understand And Download Our Tape Measure Form',
	description:
		'How to use the Tape Measure form to get accurate results for your Indow inserts.',
	showTitle: false,
});
